import axios from 'axios';
import apiEndpoints from '../globals/apiEndpoints';
import MockApi from './MockApi';
import orders from '../../fixtures/apiResponses/orders.json';

export default class Orders {
	static fetchOrders(code) {
		const formData = new FormData();
		formData.append('code', code);
		return axios.post(apiEndpoints.orders, formData, {
			headers: {
			  'Content-Type': 'multipart/form-data',
			},
		  })
		  .then((response) => response.data)
		  .catch((error) => {
			console.log('Error ' + error.message)
		  });
		// return MockApi.get({ data: orders, timeout: 1000 });
	}
}
